import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {DataLoggerDefaults, Device, Register} from "../../model/device.model";
import {ModbusService} from "../../modbusrtu/modbus.service";
import moment from "moment";
import {UtilService} from "../../shared/util.service";
import {MeterRegisters} from "../meter-overview/meter-overview.component";
import {AttributeID} from "../../model/device-attribute.model";

@Component({
    selector: 'app-logger-measurement',
    templateUrl: './logger-measurement.component.html',
    standalone: false
})
export class LoggerMeasurementComponent implements OnInit, OnChanges {

  writeList : any[] = [];

  @Input() device: Device;
  @Input() servers: any[] = [];
  @Input() deviceData: any = {};
  @Output() deviceDataChange = new EventEmitter<any>();

  children: any[] = [];

  activeLogger = 0;


  constructor(
    private modbusService: ModbusService,
    private util: UtilService
  ) { }

  ngOnInit(): void {
    this.getLoggerChildren();
    this.activeLogger = +this.device.getActiveLogger()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.deviceData) {
      this.deviceData = changes.deviceData.currentValue;
    }
    if (changes.device) {
      setTimeout(() => {this.extractQueryResult(changes.device.currentValue.registers, 'all')}, 100);
    }
  }

  getIP() {
    this.sendQuery('ip');
  }

  getPushToServerPerios() {
    this.sendQuery('push_period');
  }

  getUsername() {
    this.sendQuery('username');
  }

  sendQuery(type) {
    if (!type) {
      return;
    }
    const info = {
      deviceid: this.device.id,
      ip: this.device.getIP(),
      port: DataLoggerDefaults.port,
      device: DataLoggerDefaults.device,
      type: type
    }

    this.modbusService.query(info).subscribe((resp:any) => {
      if (resp.error) {
        return this.modbusService.notiService.open(resp.error);
      }
      this.extractQueryResult(resp, info.type)
    })
  }

  extractQueryResult(res, type) {
    if (Object.keys(res).length && type != 'all') {
      this.device.setLastCom(moment().format("YYYY-MM-DD HH:mm:ss"));
    }
    switch (type) {
      case 'ip':
        this.deviceData.ip = res["ip"];
        this.deviceData.port = res["port"];
        break;
      case 'push_period':
        this.deviceData.push_period = res[Register.push_period];
        break;
      case 'username':
        this.deviceData.username = res["username"];
        break;
      case 'all':
        this.deviceData.ip = res["ip"];
        this.deviceData.port = res["port"];
        this.deviceData.push_period = res[Register.push_period];
        break;
      default:
        console.log("undefined type handler", type);
    }
    this.deviceDataChange.emit(this.deviceData);
  }

  getLoggerChildren() {
    if (this.device && this.device.id) {
      this.modbusService.getLoggerChildren(this.device.id).subscribe((resp: any) => {
        if (resp.error) {
          return this.modbusService.notiService.open(resp.error);
        }
        if (resp.length) {
          this.children = this.checkChildrenStatusesAndOrderByIndex(resp)
        }
      })
    }
  }

  checkChildrenStatusesAndOrderByIndex(resp) {
    const devices = resp.map(r => new Device(r));
    let result = [];

    devices.forEach(d => {
      let index = d.getIndex();
      result.push({
        ...d,
        index: index,
        hasConfig: d.hasConfig(),
        serial: d.getSerialNumber(true),
        logging_period: d.registers[(+index * 100) + MeterRegisters.readfreq],
        read_freq_info: d.getReadFreq()
        }
      )
    })
    return result.sort((a, b) => (a.index > b.index) ? 1 : -1);
  }

  onLoggingPeriodChange(child) {
    if (child.logging_period > 0) {
      child.logging_period = 0;
      this.writeLoggingRegister(child);
    } else {
      const freq = +child.read_freq_info;
      if (freq > 0) {
        child.logging_period = freq;
        this.writeLoggingRegister(child);
      }
    }
  }

  writeLoggingRegister(child) {
    if (!child.parent) {
      return;
    }
    const index = child.index;
    if (index === null) {
      return this.modbusService.notiService.open("Missing device index for register writing.");
    }
    const ip = this.device.getIP();
    const data = {
      register: (+index * 100) + MeterRegisters.readfreq,
      value: child.logging_period,
      id: 'meter_register'
    }

    this.modbusService.writeMultiple({deviceid: this.device.id, ip: ip, list: [data]}).subscribe((resp:any) => {
      if (!resp.success) {
        this.modbusService.notiService.open("Something went wrong, check console log.");
        console.log(resp);
      } else {
        this.modbusService.notiService.open("Successful writing");
      }
    })
  }

  onClickAdhocBtn() {
    const ip = this.device.getIP();

    if (ip) {
      this.modbusService.write(ip, Register.ad_hoc, 1, this.device.id).subscribe((resp:any) => {
        if (resp.error) {
          return this.modbusService.notiService.open(resp.error);
        }
        this.modbusService.notiService.open("Successful adhoc register writing");
        console.log("write res", resp);
      })
    }
  }

  onPortToggleChange() {
    if (this.deviceData.port > 0) {
      this.deviceData.port = 0;
      this.addToWriteList({id: 'port', value: this.deviceData.port});
    } else {
      this.setPortToSelectedIP();
    }
  }

  onActiveLoggerChange() {
    this.activeLogger = this.activeLogger === 1 ? 0 : 1;
    this.modbusService.saveAttribute({device: this.device.id, attribute: AttributeID.activeLogger, value: this.activeLogger}).subscribe((resp:any) => {
      if (resp.success) {
        this.modbusService.notiService.open("Logger status saved");
        this.device.setActiveLogger(this.activeLogger);
      }
    })
  }

  setPortToSelectedIP(server = null) {
    if (this.deviceData.ip) {
      if (!server) {
        server = this.servers.filter(s => s.ip == this.deviceData.ip)[0];
      }
      if (server) {
        this.deviceData.port = server.port;
        this.addToWriteList({id: 'port', value: this.deviceData.port});
      }
    }
  }

  setUsernameToSelectedIP(server = null) {
    if (this.deviceData.ip) {
      if (!server) {
        server = this.servers.filter(s => s.ip == this.deviceData.ip)[0];
      }
      if (server) {
        this.deviceData.username = server.username;
        this.addToWriteList({id: 'username', value: this.deviceData.username});
      }
    }
  }

  addToWriteList(item) {
    if (this.util.isItemInArray(item, this.writeList)) {
      this.writeList = this.util.findAndReplaceItemInArray(item, this.writeList);
    } else {
      this.writeList.push(item);
    }
  }

  onIPChange() {
    const server = this.servers.filter(s => s.ip == this.deviceData.ip)[0];
    this.addToWriteList({id: 'ip', value: this.deviceData.ip});
    this.setPortToSelectedIP(server);
    this.setUsernameToSelectedIP(server);
  }
  onPushPeriodChange() {
    this.addToWriteList({id: 'push_period', value: this.deviceData.push_period});
  }

  handleWriteRegisters() {
    this.modbusService.writeMultiple({deviceid: this.device.id, ip: this.device.getIP(), list: this.writeList}).subscribe((resp:any) => {
      if (!resp.success) {
        this.modbusService.notiService.open("Something went wrong, check console log.");
        console.log(resp);
      } else {
        this.modbusService.notiService.open("Successful writing");
        this.writeList = [];
      }
    })
  }

  readRegisters() {
    this.getIP();
    this.getPushToServerPerios();
    this.getUsername();
  }

  writeRegisters() {
    this.modbusService.confirmAction(`Do you want to write these registers? ${JSON.stringify(this.writeList)}`).subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.handleWriteRegisters();
      }
    })
  }
}
